<template>
  <div class='coupons'>
    <filter-panel :data="discountGroups"
                  @search="filterChange"></filter-panel>
    <div class="button-area">
      <el-button class="feature-btn"
                 type="primary"
                 @click="addCoupons">新增</el-button>
    </div>
    <data-list :data="data"
               :columns="discountColumn"
               :table-style="{ name: 'mixture' }"
               :page="page"
               :page-size="page.pageSize"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @sort-change="sortChange"></data-list>
  </div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';

const list = listPageCreate({
  searchConfig: {
    api: api.setmeal.couponsConfigList,
    method: 'POST',
  },
});

export default {
  name: 'coupons',
  props: ['discountGroups', 'discountColumn'],
  mixins: [list],
  components: {
    filterPanel
  },
  methods: {
    addCoupons () {
      this.$router.push({
        name: 'couponsConfig',
      });
    }
  }
}
</script>

<style lang='scss' scoped>
.coupons {
	.button-area {
		width: 100%;
		height: 60px;
		margin: 10px 0;
		padding: 0 20px;
		padding-bottom: 10px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
	}
}
</style>
